import api from "../../services/api";
import { mapGetters } from "vuex";
import router from "../../router";
import localStorage from "../../services/storage";

export default {
    props: {
        showContinue: {
            type: Boolean,
            default: true
        },
        buyButtonForTopAction: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            canContinueButton: false,
            hasExternalUrl: false,
            mobileTariff: {},
            device: {},
            tVTariff: {},
            tVdevice: {},
            box: {},
            sIM: {},
            other: {},
            bundle: [],
            limit: 0,
            insurance: false,
            postBill: false,
            rightSide: {
                oneTime: 0,
                billing: 0,
                total: 0,
            },
            spec: {},
            prefix: localStorage.get('locale', true) === 'de' ? '/de' : '/sr',
            checkoutId: localStorage.get('checkout-id', true)
        };
    },

    computed: {
        ...mapGetters(['checkout', 'chosenTv', 'bonusTv']),

        actionTotals() {
            let discount = this.toPrice(this.spec.action_old_price) - this.toPrice(this.spec.action_price);
            let totalWithDiscount = this.rightSide.total;
            let totalWithoutDiscount = this.toPrice(this.rightSide.total) + discount;
      
            return {
              price: this.spec.action_price,
              oldPrice: this.spec.action_old_price,
              discount: discount.toFixed(2).replace('.', ','),
              totalWithDiscount: totalWithDiscount,
              totalWithoutDiscount: totalWithoutDiscount.toFixed(2).replace('.', ',')
            }
        },

        isSmartTariff() {
            return this.smartTariffNames.includes(this.mobileTariff.name);
        },

        bindingFirst() {
            return this.binding;
        },

        binding() {
            if (this.mobileTariff.binding == 182400001 || this.tVTariff.binding == 182400001) {
                return '24 ' + this.$i18nApi.t('months');
            }

            if (this.mobileTariff.binding == 182400002 || this.tVTariff.binding == 182400002) {
                return '1 ' + this.$i18nApi.t('oneMonth');
            }

            return '';
        },
    },

    methods: {
        reset() {
            this.mobileTariff = {};
            this.device = {};
            this.tVTariff = {};
            this.tVdevice = [];
            this.box = {};
            this.sim = {};
            this.other = {};
            this.bundle = [];
            this.limit = 0;
            this.insurance = 0;
            this.spec = {};
            this.postBill = false;
        },

        getPluralizeMonthIndex(duration) {
            const num = duration.toString().substr(duration.toString().length - 1);

            if((num == 1) && !(num == 11)) {
                return 0;
            }
            if ((num == 2 || num == 3 || num == 4) && !(duration == 12 || duration == 13 || duration == 14)){
                return 1;
            }
            if (duration == 11 || duration == 12 || duration == 13 || duration == 14){
                return 2;
            }

            return 2;
        },

        getData(enableButton = false) {
            this.canContinueButton = false;

            api.post('/public-api/checkout', this.checkout)
                .then((response) => {
                    this.reset();
                    this.processResponseData(response.data);

                    this.$root.$emit('checkoutReady');

                    if (enableButton) {
                        this.canContinueButton = true;
                    }

                    if (response.data.spec.external_checkout_url.trim().length > 0) {
                        this.hasExternalUrl = true;
                    }
                });
        },

        processResponseData(data) {
            data.items.forEach(item => {
                const key = Object.keys(item)[0];
                const value = Object.values(item)[0];

                if (key === 'tVdevice' || key === 'bundle') {
                    if (!this[key]) this[key] = [];
                    this[key].push(value);
                } else {
                    if (data.spec['action'] && key !== 'device') data.spec['action_price'] = value.total;
                    this[key] = value;
                }
            });
      
            //this.limit = data.limit;
            this.action = data.action;
            this.spec = data.spec;
            this.rightSide.oneTime = data.oneTime;
            this.rightSide.billing = data.billing;
            this.rightSide.total = data.total;
        },

        /**
         * Check if user picked Tariff but forgot to pick chanell
         * @return {*}
         */
        checkCanContiueTv() {
            if (this.bonusTv && Object.keys(this.chosenTv).length === 0) {
                return this.$swal(this.$i18nApi.t('messages.errorNotPickedChosenTv'));
            }

            router.push({ name: 'checkout-step-2' })
        },

        buyTopAction(event) {
            event.preventDefault();
            window.location.href = '/checkout/1'
        },

        toPrice(value) {
            return parseFloat(value.replace(',', '.'));
        },
    },

    mounted() {
        this.getData();

        this.$root.$on('reloadCheckout', (enableButton) => this.getData(enableButton));
        this.$root.$on('enableContinueButton', () => this.canContinueButton = true);
    },
}
